import { getPublicEnv } from "@/config/get-public-env";

const env = getPublicEnv();

export const STORAGE_KEYS = { theme: env.NEXT_PUBLIC_THEME_STORAGE_KEY, mode: env.NEXT_PUBLIC_MODE_STORAGE_KEY } as const;

export const TOKEN_KEYS = [
  "background", "foreground", "card", "popover", "muted", "muted-foreground", "border", "input",
  "primary", "primary-foreground", "link", "accent", "accent-foreground",
  "brand", "brand-foreground", "ring", "success", "warning", "destructive", "info",
] as const;

export type TokenKey = (typeof TOKEN_KEYS)[number];

export type TokenSet = Record<TokenKey, string>;
